// extracted by mini-css-extract-plugin
module.exports = {"onlineStock":"OnlineStock_onlineStock__fC_7c"};